<template>
  <div class="update_registration_page">
    <div class="first_registration">
      <div class="regist_info">
        <h1>裁判员注册页</h1>
        <div class="basic_information">
          <div class="info_left">
            <p>裁判员基本信息</p>
          </div>
          <div class="info_right">
            <registrationForm
              :operation="updateObj.type"
              :formInfo="formInfo"
              ref="registrationForm"
              :uptoken="uptoken"
            ></registrationForm>
          </div>
        </div>
        <!-- 证明材料 -->
        <div class="evidence">
          <div class="info_left">
            <p>上传材料</p>
          </div>
          <div class="info_right">
            <div class="card_box">
              <p>
                身份证照片
                <span>*</span>
              </p>
              <ul class="upload_card">
                <li>
                  <el-upload
                    v-if="updateObj.type != 'watch'"
                    :before-upload="$event=>handleBefore($event,'positive')"
                    :on-success="uploadSuccess"
                    :show-file-list="false"
                    :data="{token: uptoken}"
                    accept="image/jpeg, image/jpg, image/png"
                    action="//up-z1.qiniup.com"
                  >
                    <img
                      :src="imgList.frontImage"
                      v-if="imgList.frontImage"
                      style="width:85.6mm;height:54mm;margin-bottom:10px"
                      alt
                    />
                    <el-button
                      v-if="!imgList.frontImage"
                      :loading="loadingData.positive"
                      type="primary"
                      icon="el-icon-upload"
                    >选择上传文件</el-button>
                  </el-upload>
                  <template v-else>
                    <template
                      v-if="userInfo.type === 1 || userInfo.type === 3 || userInfo.type === 5"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="点击可查看大图"
                        placement="right-start"
                      >
                        <viewer
                          :images="[imgList.frontImage,imgList.backImage,imgList.refereeRankImage,imgList.auditImage]"
                        >
                          <img
                            :src="imgList.frontImage"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                          <img
                            :src="imgList.backImage"
                            v-show="false"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                          <img
                            :src="imgList.refereeRankImage"
                            v-show="false"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;;cursor:pointer"
                            alt
                          />
                          <img
                            :src="imgList.auditImage"
                            v-show="false"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                        </viewer>
                      </el-tooltip>
                    </template>
                    <template v-else>
                      <img
                        :src="imgList.frontImage"
                        style="width:85.6mm;height:54mm;margin-bottom:10px;"
                        alt
                      />
                    </template>
                  </template>
                  <p v-if="!imgList.frontImage" class="upload_format">只能上传jpg/png格式文件，文件不能超过5M</p>
                  <p class="upload_tip">正面</p>
                </li>
                <li>
                  <el-upload
                    v-if="updateObj.type != 'watch'"
                    :before-upload="$event=>handleBefore($event,'back')"
                    :on-success="uploadSuccess"
                    :show-file-list="false"
                    :data="{token: uptoken}"
                    accept="image/jpeg, image/jpg, image/png"
                    action="//up-z1.qiniup.com"
                  >
                    <img
                      :src="imgList.backImage"
                      v-if="imgList.backImage"
                      style="width:85.6mm;height:54mm;margin-bottom:10px"
                      alt
                    />
                    <el-button
                      v-if="!imgList.backImage"
                      :loading="loadingData.back"
                      type="primary"
                      icon="el-icon-upload"
                    >选择上传文件</el-button>
                  </el-upload>

                  <template v-else>
                    <template
                      v-if="userInfo.type === 1 || userInfo.type === 3 || userInfo.type === 5"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="点击可查看大图"
                        placement="right-start"
                      >
                        <viewer
                          :images="[imgList.frontImage,imgList.backImage,imgList.refereeRankImage,imgList.auditImage]"
                        >
                          <img
                            :src="imgList.frontImage"
                            v-show="false"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                          <img
                            :src="imgList.backImage"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                          <img
                            :src="imgList.refereeRankImage"
                            v-show="false"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;;cursor:pointer"
                            alt
                          />
                          <img
                            :src="imgList.auditImage"
                            v-show="false"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                        </viewer>
                      </el-tooltip>
                    </template>
                    <template v-else>
                      <img
                        :src="imgList.backImage"
                        style="width:85.6mm;height:54mm;margin-bottom:10px;"
                        alt
                      />
                    </template>
                  </template>
                  <p v-if="!imgList.backImage" class="upload_format">只能上传jpg/png格式文件，文件不能超过5M</p>
                  <p class="upload_tip">反面</p>
                </li>
              </ul>
            </div>
            <div class="graduation_box">
              <div>
                <p>
                  项目1裁判等级证书
                  <span>*</span>
                </p>
                <ul class="upload_card">
                  <li>
                    <el-upload
                      v-if="updateObj.type != 'watch'"
                      :before-upload="$event=>handleBefore($event,'refereeRankImage')"
                      :on-success="uploadSuccess"
                      :show-file-list="false"
                      :data="{token: uptoken}"
                      accept="image/jpeg, image/jpg, image/png"
                      action="//up-z1.qiniup.com"
                    >
                      <img
                        :src="imgList.refereeRankImage"
                        v-if="imgList.refereeRankImage"
                        style="width:85.6mm;height:54mm;margin-bottom:10px"
                        alt
                      />
                      <el-button
                        v-if="!imgList.refereeRankImage"
                        :loading="loadingData.studentFirst"
                        type="primary"
                        icon="el-icon-upload"
                      >选择上传文件</el-button>
                    </el-upload>
                    <template v-else>
                      <template
                        v-if="userInfo.type === 1 || userInfo.type === 3 || userInfo.type === 5"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="点击可查看大图"
                          placement="right-start"
                        >
                          <viewer
                            :images="[imgList.frontImage,imgList.backImage,imgList.refereeRankImage,imgList.auditImage]"
                          >
                            <img
                              :src="imgList.frontImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                            <img
                              :src="imgList.backImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                            <img
                              :src="imgList.refereeRankImage"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;;cursor:pointer"
                              alt
                            />
                            <img
                              :src="imgList.auditImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                          </viewer>
                        </el-tooltip>
                      </template>
                      <template v-else>
                        <img
                          :src="imgList.refereeRankImage"
                          style="width:85.6mm;height:54mm;margin-bottom:10px;"
                          alt
                        />
                      </template>
                    </template>
                    <p
                      v-if="!imgList.refereeRankImage"
                      class="upload_format"
                    >只能上传jpg/png格式文件，文件不能超过5M</p>
                  </li>
                </ul>
              </div>
              <div>
                <p>
                  单位审核意见书
                  <span>*</span>
                </p>
                <ul class="upload_card">
                  <li>
                    <el-upload
                      v-if="updateObj.type != 'watch'"
                      :before-upload="$event=>handleBefore($event,'studentLastImg')"
                      :on-success="uploadSuccess"
                      :show-file-list="false"
                      :data="{token: uptoken}"
                      accept="image/jpeg, image/jpg, image/png"
                      action="//up-z1.qiniup.com"
                    >
                      <img
                        :src="imgList.auditImage"
                        v-if="imgList.auditImage"
                        style="width:85.6mm;height:54mm;margin-bottom:10px"
                        alt
                      />
                      <el-button
                        v-if="!imgList.auditImage"
                        :loading="loadingData.studentLast"
                        type="primary"
                        icon="el-icon-upload"
                      >选择上传文件</el-button>
                    </el-upload>
                    <template v-else>
                      <template
                        v-if="userInfo.type === 1 || userInfo.type === 3 || userInfo.type === 5"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="点击可查看大图"
                          placement="right-start"
                        >
                          <viewer
                            :images="[imgList.frontImage,imgList.backImage,imgList.refereeRankImage,imgList.auditImage]"
                          >
                            <img
                              :src="imgList.frontImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                            <img
                              :src="imgList.backImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                            <img
                              :src="imgList.refereeRankImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;"
                              alt
                            />
                            <img
                              :src="imgList.auditImage"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                          </viewer>
                        </el-tooltip>
                      </template>
                      <template v-else>
                        <img
                          :src="imgList.auditImage"
                          style="width:85.6mm;height:54mm;margin-bottom:10px;"
                          alt
                        />
                      </template>
                    </template>
                    <p v-if="!imgList.auditImage" class="upload_format">只能上传jpg/png格式文件，文件不能超过5M</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- 备注 -->
        <div class="remark">
          <div class="info_left">
            <p>备注</p>
          </div>
          <div
            class="info_right"
            :style="{padding:updateObj.type === 'watch'?(imgList.remarksImage.length === 0?'30px 25px':'20px 25px'):'20px 25px'}"
          >
            <template v-if="updateObj.type === 'watch'">
              <p
                :style="{marginBottom:imgList.remarksImage.length === 0 ?'0':'20px'}"
              >{{!formInfo.remarks?'无':formInfo.remarks}}</p>
              <viewer :images="imgList.remarksImage">
                <img
                  style="width:100px;height:100px;margin-right:20px;cursor:pointer"
                  v-for="item in imgList.remarksImage"
                  :src="item"
                  :key="item"
                  alt
                />
              </viewer>
            </template>
            <template v-else>
              <el-input
                type="textarea"
                class="remark_input"
                v-model="query.remarks"
                :autosize="{minRows:2,maxRows:5}"
                resize="none"
                placeholder="输入内容"
              ></el-input>
              <div class="upload_img">
                <el-upload
                  action="//up-z1.qiniup.com"
                  multiple
                  :before-upload="handleBeforeMultipie"
                  :on-success="uploadSuccessMultipie"
                  :show-file-list="false"
                  :file-list="remarksFileList"
                  :limit="9"
                  :on-exceed="handleExceed"
                  :data="{token: uptoken}"
                  accept="image/jpeg, image/jpg, image/png"
                >
                  <el-button>添加附件</el-button>
                </el-upload>
                <div style="display:flex;flex-wrap:wrap">
                  <viewer class="rows" :images="imgList.remarksImage">
                    <section v-for="(item,index) in imgList.remarksImage" :key="item">
                      <img class="up_img" :src="item" alt />
                      <span class="close_btn" @click="deleteRemarkImage(index)">×</span>
                    </section>
                  </viewer>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- 审核意见，只有最后审核完成后才显示 -->
        <div
          class="examine_result"
          v-if="(userInfo.type == 1 || userInfo.type === 3 || userInfo.type === 5) && formInfo.state === 5"
        >
          <div class="info_left">
            <p>审核意见</p>
          </div>
          <div class="info_right">
            <section>
              <p class="first">省学校体协意见：</p>
              <p class="next">通过</p>
              <p class="last">{{formInfo.societyAuditTime?formInfo.societyAuditTime:''}}</p>
            </section>
          </div>
        </div>
        <!-- 须知 -->
        <div
          class="notice"
          v-if="(userInfo.type === 1 && formInfo.state === 3) || (userInfo.type === 3 && formInfo.state === 3) || (userInfo.type === 5 && formInfo.state === 3) ||  (userInfo.type === 4 && updateObj.type !== 'watch')"
        >
          <div class="notice_left">
            <p>须知</p>
          </div>
          <div class="notice_right" v-if="showStep">
            <el-checkbox v-model="checked">本人已知晓浙江省教育厅关于裁判员资格的相关规定，承诺所填内容真实。</el-checkbox>
          </div>
          <template v-else>
            <!-- 分会审核员及学校管理员 -->
            <div
              v-if="userInfo.type === 3 || userInfo.type === 1 || userInfo.type === 5"
              style="padding:10px;"
            >
              <p style="padding:20px">
                <span>本人已知晓浙江省教育厅关于裁判员资格的相关规定，承诺所填内容真实。</span>
                <span style="color:#409EFF;margin-left:40px">裁判员提交时间：{{formInfo.createDate}}</span>
              </p>
            </div>
          </template>
        </div>
        <!-- 驳回理由 -->
        <div class="reject_reason" v-if="formInfo.state === 2 || formInfo.state === 4">
          <div class="info_left">
            <p>驳回理由</p>
          </div>
          <div class="info_right">{{!formInfo.reason?'无':formInfo.reason}}</div>
        </div>
      </div>
    </div>
    <div class="btn_box" v-if="updateObj.type !== 'watch'">
      <el-button
        style="width:90px"
        :loading="saveLoading"
        :disabled="!checked"
        class="save_btn"
        @click="submits(0)"
      >保存</el-button>
      <el-button
        :disabled="!checked"
        style="width:90px;margin:0 40px"
        class="normal_btn"
        :loading="btnLoading"
        @click="submits(1)"
      >提交</el-button>
      <el-button style="width:90px" v-if="false" class="normal_btn">打印</el-button>
    </div>
    <div v-else class="show_steps">
      <template v-if="showStep">
        <ul class="steps">
          <li class="submits" :style="{color:formInfo.state === 0?'#333':'#1E63B0'}">
            <span
              v-if="formInfo.state === 0"
              class="circle"
              :class="formInfo.state === 0?'in_there':''"
            >1</span>
            <i v-else class="el-icon-circle-check" style="font-size:24px;margin-right:6px"></i>
            {{formInfo.state === 0?'待提交':'已提交'}}
            <span
              class="line"
              :style="{background:formInfo.state > 0?'#1E63B0':'#979797'}"
            ></span>
          </li>
          <li
            class="steps_next"
            :style="{color:formInfo.state < 3?'#999':formInfo.state === 3?'':formInfo.state === 4?'#f56c6c':'#1E63B0'}"
          >
            <span
              v-if="formInfo.state <= 3"
              :class="formInfo.state < 3?'normal_color':'in_there'"
              class="circle"
            >2</span>
            <i
              v-else-if="formInfo.state === 4"
              class="el-icon-circle-close"
              style="font-size:24px;margin-right:6px"
            ></i>
            <i v-else class="el-icon-circle-check" style="font-size:24px;margin-right:6px"></i>
            {{formInfo.state < 3?'协会待审核':formInfo.state === 3?'协会审核中':formInfo.state === 4?'协会审核驳回':'协会审核通过'}}
            <span
              class="line"
              :style="{background:formInfo.state >= 5?'#1E63B0':'#979797'}"
            ></span>
          </li>
          <li class="steps_last" :style="{color:formInfo.state < 5?'#999':'#1E63B0'}">
            <span
              v-if="formInfo.state < 5"
              class="circle"
              :class="formInfo.state < 5?'normal_color':'in_there'"
            >3</span>
            <i v-else class="el-icon-circle-check" style="font-size:24px;margin-right:6px"></i>
            完成
          </li>
        </ul>
      </template>
      <!-- userInfo.type === 4 -->
      <el-button style="width:90px" class="normal_btn" v-if="false">打印</el-button>
    </div>
    <div class="btn_box" style="margin-top:20px;" v-if="!showStep">
      <el-button
        :disabled="!examine && userInfo.type === 2"
        style="width:100px;margin-right:40px;padding:12px 0;text-align:center"
        type="primary"
        :loading="loadingData.passLoading"
        @click="passAndSubmit"
      >通过并提交</el-button>
      <el-button style="width:100px" type="danger" @click="rejects">驳回</el-button>
    </div>
    <el-dialog
      width="700px"
      title="驳回理由"
      :visible.sync="rejectData.rejectVisible"
      :lock-scroll="false"
      :append-to-body="true"
      center
      @close="closeRejectDialog"
      :close-on-click-modal="false"
    >
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="rejectData.reason"
        resize="none"
        height="450px"
        maxlength="200"
        show-word-limit
        :autosize="{ minRows: 8, maxRows: 15}"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="rejectData.submitLoading"
          style="width:90px;margin-right:40px"
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
        <el-button style="width:90px;" @click="handleCancel">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import registerData from "@/assets/json/register.json";
import registrationForm from "./registration_form";
import { getUploadToken } from "@/api/upload.js";
import { method } from "@/utils/utils";
import {
  refereeDetails,
  updateReferee,
  societyAuditReferee
} from "@/api/judge.js";
import { message, btn } from "@/common/js/mixins.js";
import { getSession } from "@/utils/storage.js";
export default {
  mixins: [message, btn],
  components: {
    registrationForm
  },
  props: {
    updateObj: {
      type: Object
    }
  },
  data() {
    return {
      rejectData: {
        rejectVisible: false, // 审核驳回弹窗状态
        reason: "", //驳回原因
        submitLoading: false
      },

      examine: false,
      saveLoading: false,
      userInfo: JSON.parse(getSession("userInfo")) || null,
      formInfo: {},
      checked: false,
      files: "",
      fileList: [],
      remarksFileList: [],
      uptoken: "",
      uploadType: "",
      imgList: {
        frontImage: "", //身份证正面(图片)
        backImage: "", //身份证背面(图片)
        refereeRankImage: "", // 学生证照片第一面
        auditImage: "", //学生证照片第二面
        remarksImage: [] //附件图片
      },
      query: {
        frontImage: "", //身份证正面
        backImage: "", //身份证背面
        refereeRankImage: "",
        auditImage: "",
        remarks: "",
        remarksImage: [],
        id: this.updateObj.id
      },
      loadingData: {
        positive: false,
        back: false,
        studentFirst: false,
        studentLast: false,
        passLoading: false
      }
    };
  },
  watch: {
    updateObj: {
      deep: true,
      handler(value) {
        if (value.id) {
          this.getDetails(value.id, value.type);
        }
      }
    }
  },
  computed: {
    showStep() {
      let type = this.userInfo ? this.userInfo.type : null;
      let { state } = this.formInfo;
      switch (type) {
        // 学校管理员
        case 1: {
          if (state === 3) return false;
          else return true;
        }
        // 学校审核员
        case 2: {
          return true;
        }
        // 分会审核会
        case 3: {
          if (state === 3) return false;
          else return true;
        }
        // 学校注册员
        case 4: {
          return true;
        }
        default: {
          if (state === 3) return false;
          else return true;
        }
      }
    }
  },
  methods: {
    // 打开驳回理由弹窗
    rejects() {
      this.rejectData.rejectVisible = true;
    },
    // 驳回弹窗关闭
    closeRejectDialog() {
      this.rejectData.reason = "";
      this.rejectData.submitLoading = false;
    },
    // 驳回弹窗关闭
    handleCancel() {
      this.rejectData.rejectVisible = false;
    },
    // 驳回提交
    handleSubmit() {
      this.rejectData.submitLoading = true;
      societyAuditReferee({
        ids: this.formInfo.id,
        state: 4,
        reason: this.rejectData.reason
      })
        .then(res => {
          this.rejectData.rejectVisible = false;
          this.rejectData.submitLoading = false;
          this.openSuccess("操作成功!");
          this.$emit("examineSubmit");
        })
        .catch(err => {
          this.rejectData.rejectVisible = false;
          this.rejectData.submitLoading = false;
        });
    },
    // 审核通过
    passAndSubmit() {
      this.loadingData.passLoading = true;
      societyAuditReferee({
        ids: this.formInfo.id,
        state: 5
      })
        .then(res => {
          this.openSuccess("操作成功!");
          this.$emit("examineSubmit");
          this.loadingData.passLoading = false;
        })
        .catch(err => {
          this.loadingData.passLoading = false;
        });
    },
    // 获取token
    getToken() {
      getUploadToken({
        type: 1
      })
        .then(res => {
          this.uptoken = res;
        })
        .catch(err => {});
    },
    // 超出上传限制个数
    handleExceed() {
      this.openWarn("最多只能上传9张图片！");
    },
    // 删除附件图片
    deleteRemarkImage(index) {
      this.remarksFileList.splice(index, 1);
      this.imgList.remarksImage.splice(index, 1);
      this.query.remarksImage.splice(index, 1);
    },
    // 附件上传前判断size及文件格式
    handleBeforeMultipie(file) {
      var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 <= 5; //图片大小不超过5MB
      if (!testmsg) {
        this.$message.error("上传图片格式不对!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        return false;
      }
      this.fileList.push(file);
      return testmsg && isLt5M;
    },
    // 附件上传成功
    uploadSuccessMultipie(data, file, fileList) {
      this.remarksFileList = fileList;
      this.query.remarksImage.push(data.key);
      this.imgList.remarksImage.push(window.URL.createObjectURL(file.raw));
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].name === file.name) {
          this.fileList.splice(i, 1);
          i--;
        }
      }
    },
    // 上传前判断size及文件格式
    handleBefore(file, type) {
      this.uploadType = type;
      this.files = file;
      if (type === "positive") this.loadingData.positive = true;
      else if (type === "back") this.loadingData.back = true;
      else if (type === "refereeRankImage")
        this.loadingData.studentFirst = true;
      else this.loadingData.studentLast = true;
      var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 <= 5; //图片大小不超过5MB
      if (!testmsg) {
        this.$message.error("上传图片格式不对!");
        Object.assign(this.loadingData, {
          positive: false,
          back: false,
          studentFirst: false,
          studentLast: false
        });
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        Object.assign(this.loadingData, {
          positive: false,
          back: false,
          studentFirst: false,
          studentLast: false
        });
        return false;
      }
      return testmsg && isLt5M;
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      this.$message.success("上传成功！");
      if (this.uploadType === "positive") {
        this.query.frontImage = response.key;
        this.imgList.frontImage = window.URL.createObjectURL(this.files);
        this.loadingData.positive = false;
      } else if (this.uploadType === "back") {
        this.query.backImage = response.key;
        this.imgList.backImage = window.URL.createObjectURL(this.files);
        this.loadingData.back = false;
      } else if (this.uploadType === "refereeRankImage") {
        this.loadingData.studentFirst = false;
        this.query.refereeRankImage = response.key;
        this.imgList.refereeRankImage = window.URL.createObjectURL(this.files);
      } else {
        this.loadingData.studentLast = false;
        this.query.auditImage = response.key;
        this.imgList.auditImage = window.URL.createObjectURL(this.files);
      }
    },
    // 返回上级
    backs() {
      this.$emit("clearUpdate");
    },
    // 点击提交按钮
    submits(type) {
      this.$refs.registrationForm
        .submits()
        .then(res => {
          if (!res) return;
          let {
            frontImage,
            backImage,
            refereeRankImage,
            auditImage,
            id,
            remarksImage,
            remarks
          } = this.query;
          let { headImage } = res;
          /**
           * 图片地址截取
           */
          frontImage = frontImage.split("/")[frontImage.split("/").length - 1];
          backImage = backImage.split("/")[backImage.split("/").length - 1];
          refereeRankImage = refereeRankImage.split("/")[
            refereeRankImage.split("/").length - 1
          ];
          auditImage = auditImage.split("/")[auditImage.split("/").length - 1];
          headImage = headImage.split("/")[headImage.split("/").length - 1];
          if (type === 0) this.saveLoading = true;
          else this.openBtn();
          let arr = [];
          remarksImage.filter(item => {
            if (item.split("/").length > 1) {
              arr.push(item.split("/")[item.split("/").length - 1]);
            } else {
              arr.push(item.split("/")[0]);
            }
          });
          updateReferee({
            ...res,
            frontImage,
            backImage,
            refereeRankImage,
            auditImage,
            headImage,
            remarks,
            passDate: res.projectJson[0].passDate,
            refereeRank: res.projectJson[0].refereeRank,
            remarksImage: arr.join(","),
            state: type === 0 ? 0 : 3,
            id
          })
            .then(res => {
              if (type === 0) this.saveLoading = false;
              else this.closeBtn();
              this.$message({
                type: "success",
                message: type === 0 ? "保存成功！" : "提交成功！"
              });
              this.backs();
            })
            .catch(err => {
              if (type === 0) this.saveLoading = false;
              else this.closeBtn();
            });
        })
        .catch(err => {});
    },
    // 获取详情
    getDetails(id, type) {
      refereeDetails({ id })
        .then(res => {
          this.checked = true;
          this.remarksFileList = [];
          if (res.birthday) {
            res.birthday = method.timeFormat(res.birthday);
          }
          if (res.passDate) {
            res.passDate = method.timeFormat(res.passDate);
          }
          if (res.createDate) {
            res.createDate = method.timeFormat(res.createDate);
          }
          if (res.societyAuditTime) {
            res.societyAuditTime = method.timeFormat(res.societyAuditTime);
          }
          for (let item in res) {
            if (this.query.hasOwnProperty(item)) {
              if (item === "remarksImage") {
                if (res[item]) {
                  let remarksImg = res[item].split(",");
                  let arr = [];
                  remarksImg.filter((temp, index) => {
                    arr.push("https://matchvideo.328ym.com/" + temp);
                    this.remarksFileList.push({
                      name: "img" + index,
                      url: temp
                    });
                  });

                  this.$set(this.query, item, [...arr]);
                  this.$set(this.imgList, item, [...arr]);
                } else {
                  this.$set(this.query, "remarksImage", []);
                  this.$set(this.imgList, "remarksImage", []);
                }
              } else {
                this.$set(this.query, item, res[item]);
                this.$set(this.imgList, item, res[item]);
              }
            }
          }
          this.formInfo = res;
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getToken();
    this.getDetails(this.updateObj.id, this.updateObj.type);
  }
};
</script>
<style lang="less" scoped>
@borders: 1px solid #979797;
.update_registration_page {
  .first_registration {
    border: @borders;
    min-width: 900px;
    max-width: 1320px;
    margin: 0 auto;
    .regist_info {
      width: 100%;
      min-width: 900px;
      > h1 {
        line-height: 64px;
        text-align: center;
        font-size: 24px;
        color: #222;
      }
      > .basic_information {
        border-top: @borders;
        display: flex;
        min-width: 900px;

        .info_right {
          flex: 1;
        }
      }
    }
    .info_left {
      width: 100px;
      border-right: @borders;
      display: flex;
      align-items: center;
      justify-content: center;
      > p {
        line-height: 24px;
        width: 24px;
        font-size: 20px;
        text-align: center;
      }
    }
    .evidence {
      border-top: @borders;
      display: flex;
      .info_right {
        padding: 20px 25px;
        flex: 1;
        p {
          display: flex;
          span {
            color: #fd6666;
          }
        }
        .upload_card {
          margin: 20px 0;
          width: 100%;
          display: flex;
          justify-content: space-between;
          li {
            width: 48%;
            height: 300px;
            background: #e6e6e6;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .upload_format {
              font-size: 14px;
              margin: 20px 0;
            }
            .upload_tip {
              font-size: 18px;
            }
          }
        }
      }
      .graduation_box {
        display: flex;
        justify-content: space-between;
        width: 100%;
        > div {
          width: 48%;
          li {
            width: 100% !important;
          }
        }
      }
    }
    .remark {
      border-top: @borders;
      display: flex;
      align-items: center;
      .info_left {
        width: 99px;
        border-right: none;
      }
      .info_right {
        border-left: @borders;
        flex: 1;
        .upload_img {
          display: flex;
        }
        .rows {
          display: flex;
          flex-wrap: wrap;
          > section {
            width: 100px;
            height: 100px;
            position: relative;
            margin: 0 0 20px 20px;
            > .up_img {
              cursor: pointer;
              border: 1px solid rgba(0, 0, 0, 0.2);
              width: 100%;
              height: 100%;
            }
            > .close_btn {
              cursor: pointer;
              position: absolute;
              top: -6px;
              right: -6px;
              width: 14px;
              height: 14px;
              line-height: 12px;
              font-size: 12px;
              color: #fff;
              text-align: center;
              background: #1e63b0;
              border-radius: 50%;
            }
          }
        }
      }
      /deep/ .remark_input .el-textarea__inner {
        border: none;
      }
    }
    .examine_result {
      border-top: @borders;
      display: flex;
      .info_right {
        display: flex;
        padding: 0;
        flex: 1;
        > section {
          height: 150px;
          width: 100%;
          padding: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .first {
            font-size: 16px;
          }
          .next {
            font-size: 24px;
            text-align: center;
          }
          .last {
            font-size: 16px;
            text-align: right;
          }
        }
      }
    }
    .notice {
      border-top: @borders;
      display: flex;
      height: 64px;
      align-items: center;
      .notice_left {
        height: 64px;
        border-right: @borders;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        > p {
          line-height: 24px;
          width: 24px;
          font-size: 20px;
        }
      }
      .notice_right {
        padding-left: 25px;
      }
    }
    .reject_reason {
      border-top: @borders;
      display: flex;
      .info_left {
        width: 100px;
        font-size: 24px;
        border-right: @borders;
        padding: 20px;
      }
      .info_right {
        padding: 20px 25px;
        line-height: 20px;
        flex: 1;
      }
    }
  }
  .btn_box {
    margin: 40px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .show_steps {
    display: flex;
    margin: 24px 104px 0;
    align-items: center;
    .steps {
      display: flex;
      align-items: center;
      flex: 1;
      > li {
        display: flex;
        align-items: center;
        &.submits {
          color: #1e63b0;
          .line {
            background: #1e63b0;
          }
        }
        .line {
          width: 104px;
          height: 1px;
          margin: 0 10px;
        }
      }
      > .submits,
      .steps_second,
      .steps_next,
      .steps_last {
        .circle {
          width: 24px;
          font-size: 14px;
          border-radius: 50%;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          margin-right: 6px;
        }
      }
      .in_there {
        background: #1e63b0;
      }
      .normal_color {
        background: transparent;
        border: 1px solid #999;
        color: #999 !important;
      }
    }
  }
}
</style>